import { DonationCategory } from "../Payment/constant";

export const annaDaan = [
  " Anna Daan is Maha Daan. Lord Krishna is extremely pleased to bless a devotee who renders even a little service to Him.",

  "In Mahabharata, Yudhishthira Maharaj enquired:'What gift will reward in this world and in the next?' Bhismadev answered:'There has never been, nor will there ever be, any gift equal to the gift of food.-Anusasana Parva 13.63.3-6",

  "Please grab the opportunity to get the blessings of Lord Krishna by rendering this important service of Anna Daan Seva.",
];

export const donationCategories: DonationCategory[] = [
  {
    title: "AnnaDaan",
    donations: [
      { id: 1, title: "Donate 25 Meals", amount: 1000 },
      { id: 2, title: "Donate 50 Meals", amount: 2000 },
      { id: 3, title: "Donate 100 Meals", amount: 4000 },
      { id: 4, title: "Donate 125 Meals", amount: 5000 },
      { id: 5, title: "Donate 250 Meals", amount: 10000 },
      { id: 6, title: "Donate 500 Meals", amount: 20000 },
      { id: 7, title: "Donate 1000 Meals", amount: 40000 },
      { id: 8, title: "Donate 1250 Meals", amount: 50000 },
      { id: 9, title: "Donate 2500 Meals", amount: 100000 },
      { id: 10, title: "Donate 5000 Meals", amount: 200000 },
      { id: 11, title: "Donate 7500 Meals", amount: 300000 },
      { id: 12, title: "Donate 10000 Meals", amount: 400000 },
      { id: 13, title: "Donate 12500 Meals", amount: 500000 },
    ],
  },
];
